/**
 * Pure Denticon patient-page detection.
 * Popup and adapters share this module so neither needs a content-adapter registry.
 */

export const PATIENT_PAGE_PATTERNS: readonly string[] = [
  '/AdvancedPatientOverview.aspx',
  '/PatientOverview.aspx',
  '/PatientOverview/',
  '/AdvancedTransactionEntry.aspx',
  '/AdvancedLedger.aspx',
  '/AdvancedCharting.aspx',
  '/AdvancedTreatPlanQuickEntry.aspx',
  '/EditPrescription/',
  '/Notes/Index',
  '/EditRecalls/',
  '/AdvancedPatientMedicalhistory.aspx',
  '/DenticonInsights/',
  '/ContractPlan/',
  '/AdvancedOrthoContract.aspx',
  '/AdvancedFlashAlerts.aspx',
  '/PatientStatusTracker/',
  '/PatientCariesRiskSetup/',
  '/PatBasicMeasures.aspx',
  '/ChangeHomeOffice/',
  '/AssignToRestrictedUser/',
  '/Addresses/Index',
  '/UncloseAccountStmt/',
  '/ReallocateAccount/',
  '/advancededitpatientinsurance.aspx',
  '/EditDentalFillOut/',
  '/EditMedicalFillOut/',
  '/VitalSign.aspx',
  '/ProblemList.aspx',
  '/SmokingHistory.aspx',
  '/OrderLabTest.aspx',
  '/PatVaccineSetup.aspx',
  '/PatEducationHistory.aspx',
  '/DashboardStage2Modified.aspx',
  '/Encounters.aspx',
  '/EditAllergy.aspx',
  '/PatSummaryOfCare.aspx',
  '/EHRPatReconileList.aspx',
  '/Interventions.aspx',
  '/CQMNotPerformed.aspx',
];

/**
 * @param pathname - URL pathname (may be empty when only href is known)
 * @param _href - Full URL (accepted for PmsCatalogEntry.isPatientPage signature compatibility)
 * @returns True on Denticon patient surfaces
 */
export function isDenticonPatientPage(
  pathname: string | null | undefined,
  _href?: string | null,
): boolean {
  if (!pathname) return false;
  const path = String(pathname || '').toLowerCase();
  return PATIENT_PAGE_PATTERNS.some(p => path.includes(p.toLowerCase()));
}
